// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__24jZ9","footer":"ModalFilter_footer__2iAWN"};